exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-background thead{background-color:#a9e4ce;border:2px solid #d3d3d3;border-bottom-style:none;height:40px;position:sticky;top:0;font-size:11px}.my-custom-scrollbar{position:relative;height:550px;overflow:auto}.my-custom-scrollbar_xAxis{position:relative;height:340px;overflow:auto}.table-wrapper-scroll-y{display:block}.md-body-1,.pendencyBody{font-size:11px;font-weight:400;letter-spacing:.01em;line-height:20px}.table-background>tbody{font-size:11px}.table-background>thead{color:#000}.blink{animation:blinker 1s linear infinite;font-weight:800;color:red}.blink-circle{width:10px;height:10px;background-color:red;border-radius:50%;animation:blinker 6s linear infinite}@keyframes blinker{50%{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fc8102a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Pendency/ccImpPendency.vue
// module id = 1429
// module chunks = 0